import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { XCircle, ArrowLeft } from 'lucide-react';

const CheckoutCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-20">
      <div className="glass-card p-8 max-w-md w-full text-center">
        <div className="w-20 h-20 rounded-full bg-destructive/20 flex items-center justify-center mx-auto mb-6">
          <XCircle className="w-12 h-12 text-destructive" />
        </div>
        <h1 className="text-2xl font-bold mb-2">Pago Cancelado</h1>
        <p className="text-muted-foreground mb-6">
          Tu proceso de pago fue cancelado. No se realizó ningún cargo.
        </p>
        <div className="space-y-3">
          <Button
            className="w-full"
            onClick={() => navigate(-1)}
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Volver al Evento
          </Button>
          <Button
            variant="outline"
            className="w-full"
            onClick={() => navigate('/events')}
          >
            Explorar Eventos
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CheckoutCancel;
